export default __webpack_public_path__ + "static/media/Density.c68b489e.jpg";